/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type FleetMapLineServiceConfigQueryVariables = Types.Exact<{
  serviceAreaId: Types.Scalars['ID']['input']
}>

export type FleetMapLineServiceConfigQuery = {
  __typename?: 'Query'
  lineServiceConfig: {
    __typename?: 'LineServiceConfig'
    enabled: boolean
    serviceAreaId: string
  }
}

export const FleetMapLineServiceConfigDocument = gql`
    query FleetMapLineServiceConfig($serviceAreaId: ID!) {
  lineServiceConfig(serviceAreaId: $serviceAreaId) {
    enabled
    serviceAreaId
  }
}
    `

/**
 * __useFleetMapLineServiceConfigQuery__
 *
 * To run a query within a React component, call `useFleetMapLineServiceConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useFleetMapLineServiceConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFleetMapLineServiceConfigQuery({
 *   variables: {
 *      serviceAreaId: // value for 'serviceAreaId'
 *   },
 * });
 */
export function useFleetMapLineServiceConfigQuery(
  baseOptions: Apollo.QueryHookOptions<
    FleetMapLineServiceConfigQuery,
    FleetMapLineServiceConfigQueryVariables
  > &
    (
      | { variables: FleetMapLineServiceConfigQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    FleetMapLineServiceConfigQuery,
    FleetMapLineServiceConfigQueryVariables
  >(FleetMapLineServiceConfigDocument, options)
}
export function useFleetMapLineServiceConfigLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FleetMapLineServiceConfigQuery,
    FleetMapLineServiceConfigQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    FleetMapLineServiceConfigQuery,
    FleetMapLineServiceConfigQueryVariables
  >(FleetMapLineServiceConfigDocument, options)
}
// @ts-ignore
export function useFleetMapLineServiceConfigSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    FleetMapLineServiceConfigQuery,
    FleetMapLineServiceConfigQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  FleetMapLineServiceConfigQuery,
  FleetMapLineServiceConfigQueryVariables
>
export function useFleetMapLineServiceConfigSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FleetMapLineServiceConfigQuery,
        FleetMapLineServiceConfigQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  FleetMapLineServiceConfigQuery | undefined,
  FleetMapLineServiceConfigQueryVariables
>
export function useFleetMapLineServiceConfigSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FleetMapLineServiceConfigQuery,
        FleetMapLineServiceConfigQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    FleetMapLineServiceConfigQuery,
    FleetMapLineServiceConfigQueryVariables
  >(FleetMapLineServiceConfigDocument, options)
}
export type FleetMapLineServiceConfigQueryHookResult = ReturnType<
  typeof useFleetMapLineServiceConfigQuery
>
export type FleetMapLineServiceConfigLazyQueryHookResult = ReturnType<
  typeof useFleetMapLineServiceConfigLazyQuery
>
export type FleetMapLineServiceConfigSuspenseQueryHookResult = ReturnType<
  typeof useFleetMapLineServiceConfigSuspenseQuery
>
export type FleetMapLineServiceConfigQueryResult = Apollo.QueryResult<
  FleetMapLineServiceConfigQuery,
  FleetMapLineServiceConfigQueryVariables
>
